import React from "react";
export const Page404 = () => {
  return (
    <div>
      <h1>404</h1>
      <h2>Page not found</h2>
    </div>
  );
};
